import React from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useVersionCheck } from '../../hooks/useVersionCheck';

/**
 * A slim banner pinned to the top of the app that appears when a newer build
 * has been deployed, prompting the user to refresh. Driven by useVersionCheck.
 */
function VersionUpdateBanner() {
  const { updateAvailable, latestVersion, dismiss, reload } = useVersionCheck();

  if (!updateAvailable) return null;

  const versionText = latestVersion?.version ? ` (v${latestVersion.version})` : '';

  return (
    <div className="fixed top-0 inset-x-0 z-[9999] bg-[#fed402] text-[#1a1818] shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-3 flex-wrap">
        <RefreshCw className="w-4 h-4 flex-shrink-0" />
        <span className="text-sm font-medium">
          A new version of the portal is available{versionText}.
        </span>
        <button
          onClick={reload}
          className="ml-1 px-3 py-1 bg-[#1a1818] text-white rounded-md text-sm font-medium hover:bg-black transition-colors duration-200"
        >
          Refresh now
        </button>
        <button
          onClick={dismiss}
          aria-label="Dismiss"
          className="p-1 rounded-md hover:bg-black/10 transition-colors duration-200"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}

export default VersionUpdateBanner;
